import { FC } from "react";
import { AppPartType } from "../../../types";
import { Input } from "antd";
import { UNIT_OF_MEASURE_TYPE } from "../../../constants";

type Prop = {
  appPart: AppPartType;
};
const Number: FC<Prop> = ({
  appPart: { default_value, unit_of_measure, unit_of_measure_type },
}) => {
  return (
    <Input
      value={default_value}
      addonBefore={
        unit_of_measure_type === UNIT_OF_MEASURE_TYPE.frefix ||
        unit_of_measure_type === UNIT_OF_MEASURE_TYPE.frefix_suffix
          ? unit_of_measure
          : ""
      }
      className="align-right"
      addonAfter={
        unit_of_measure_type === UNIT_OF_MEASURE_TYPE.suffix ||
        !unit_of_measure_type ||
        unit_of_measure_type === UNIT_OF_MEASURE_TYPE.frefix_suffix
          ? unit_of_measure
          : ""
      }
    />
  );
};

export default Number;
